import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VerificationPage from './VerificationPage';
import HomePage from './HomePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/:guid" element={<VerificationPage />} />
          <Route path="/home" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
